module.exports = __webpack_public_path__ + "static/img/file_shell.9c016a4f.png";